import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { LotsValidationPage } from '@contracts';

export const Route = createFileRoute('/_app/os/lots')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.LotsValidation);
  },
  component: LotsValidationPage,
  errorComponent: LotsValidationPage.Error,
});
